import React, { useState, useEffect } from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Container,
  Tabs,
  Tab,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Grid,
  Card,
  CardContent,
  IconButton,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Collapse,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import WorkIcon from '@mui/icons-material/Work';
import ChatIcon from '@mui/icons-material/Chat';
import FolderIcon from '@mui/icons-material/Folder';
import PeopleIcon from '@mui/icons-material/People';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RefreshIcon from '@mui/icons-material/Refresh';
import Avatar from '@mui/material/Avatar';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import SchoolIcon from '@mui/icons-material/School';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CategoryIcon from '@mui/icons-material/Category';
import LabelIcon from '@mui/icons-material/Label';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ArchiveIcon from '@mui/icons-material/Archive';
import InboxIcon from '@mui/icons-material/Inbox';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import SportsIcon from '@mui/icons-material/Sports';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import FlightIcon from '@mui/icons-material/Flight';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HotelIcon from '@mui/icons-material/Hotel';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SecurityIcon from '@mui/icons-material/Security';
import LockIcon from '@mui/icons-material/Lock';
import PublicIcon from '@mui/icons-material/Public';
import CodeIcon from '@mui/icons-material/Code';
import ComputerIcon from '@mui/icons-material/Computer';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventIcon from '@mui/icons-material/Event';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import ForumIcon from '@mui/icons-material/Forum';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import StoreIcon from '@mui/icons-material/Store';
import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HistoryIcon from '@mui/icons-material/History';
import ScheduleIcon from '@mui/icons-material/Schedule';
import NoteIcon from '@mui/icons-material/Note';
import ArticleIcon from '@mui/icons-material/Article';
import CollectionsIcon from '@mui/icons-material/Collections';
import MovieIcon from '@mui/icons-material/Movie';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const drawerWidth = 280;

// Список доступных иконок для папок
const folderIcons = {
  Folder: FolderIcon,
  FolderOpen: FolderOpenIcon,
  Work: WorkIcon,
  Business: BusinessIcon,
  Home: HomeIcon,
  Star: StarIcon,
  Favorite: FavoriteIcon,
  Settings: SettingsIcon,
  Build: BuildIcon,
  School: SchoolIcon,
  ShoppingCart: ShoppingCartIcon,
  Category: CategoryIcon,
  Label: LabelIcon,
  Bookmark: BookmarkIcon,
  Archive: ArchiveIcon,
  Inbox: InboxIcon,
  Description: DescriptionIcon,
  Image: ImageIcon,
  VideoLibrary: VideoLibraryIcon,
  MusicNote: MusicNoteIcon,
  Sports: SportsIcon,
  Restaurant: RestaurantIcon,
  Flight: FlightIcon,
  DirectionsCar: DirectionsCarIcon,
  Hotel: HotelIcon,
  LocalHospital: LocalHospitalIcon,
  AccountBalance: AccountBalanceIcon,
  Security: SecurityIcon,
  Lock: LockIcon,
  Public: PublicIcon,
  Code: CodeIcon,
  Computer: ComputerIcon,
  Phone: PhoneIcon,
  Email: EmailIcon,
  CalendarToday: CalendarTodayIcon,
  Event: EventIcon,
  Notifications: NotificationsIcon,
  Assignment: AssignmentIcon,
  CheckCircle: CheckCircleIcon,
  Warning: WarningIcon,
  Info: InfoIcon,
  Help: HelpIcon,
  Forum: ForumIcon,
  Group: GroupIcon,
  Person: PersonIcon,
  BusinessCenter: BusinessCenterIcon,
  Store: StoreIcon,
  Payment: PaymentIcon,
  AttachMoney: AttachMoneyIcon,
  TrendingUp: TrendingUpIcon,
  BarChart: BarChartIcon,
  Dashboard: DashboardIcon,
  History: HistoryIcon,
  Schedule: ScheduleIcon,
  Note: NoteIcon,
  Article: ArticleIcon,
  Collections: CollectionsIcon,
  Movie: MovieIcon,
  LibraryMusic: LibraryMusicIcon,
};

// Функция для получения компонента иконки по имени
const getIconComponent = (iconName) => {
  if (!iconName || !folderIcons[iconName]) {
    return FolderIcon;
  }
  const IconComponent = folderIcons[iconName];
  return IconComponent;
};

const ProjectManagement = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { projectUuid } = useParams();
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Чаты
  const [chats, setChats] = useState([]);
  const [folders, setFolders] = useState([]);
  const [chatDialogOpen, setChatDialogOpen] = useState(false);
  const [chatForm, setChatForm] = useState({ name: '', description: '', folder_id: '' });
  const [connectionInfo, setConnectionInfo] = useState(null);

  // Папки
  const [folderDialogOpen, setFolderDialogOpen] = useState(false);
  const [folderForm, setFolderForm] = useState({ name: '', description: '', icon: 'Folder', color: '#1976d2' });
  const [editFolderDialogOpen, setEditFolderDialogOpen] = useState(false);
  const [deleteFolderDialogOpen, setDeleteFolderDialogOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [iconPickerOpen, setIconPickerOpen] = useState(false);

  // Сотрудники
  const [members, setMembers] = useState([]);
  const [addMemberDialogOpen, setAddMemberDialogOpen] = useState(false);
  const [userUuidInput, setUserUuidInput] = useState('');
  const [selectedChatsForMember, setSelectedChatsForMember] = useState([]);
  const [memberRole, setMemberRole] = useState('member');
  const [editMemberChatsDialogOpen, setEditMemberChatsDialogOpen] = useState(false);
  const [selectedMemberForEdit, setSelectedMemberForEdit] = useState(null);
  const [expandedChatFolders, setExpandedChatFolders] = useState({});

  // Удаление чата
  const [deleteChatDialogOpen, setDeleteChatDialogOpen] = useState(false);
  const [selectedChatForDelete, setSelectedChatForDelete] = useState(null);

  // Перемещение чата
  const [moveChatDialogOpen, setMoveChatDialogOpen] = useState(false);
  const [selectedChatForMove, setSelectedChatForMove] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (projectUuid) {
      const project = projects.find(p => p.uuid === projectUuid);
      if (project) {
        setSelectedProject(project);
      }
    } else if (projects.length > 0) {
      navigate(`/projects/${projects[0].uuid}`, { replace: true });
    }
  }, [projectUuid, projects]);

  useEffect(() => {
    if (selectedProject) {
      fetchChats();
      fetchFolders();
      fetchMembers();
    }
  }, [selectedProject]);

  const fetchProjects = async () => {
    try {
      const response = await axios.get('/api/projects');
      setProjects(response.data.projects || []);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Ошибка загрузки проектов');
    }
  };

  const fetchChats = async () => {
    if (!selectedProject) return;
    try {
      const response = await axios.get(`/api/chats?project_uuid=${selectedProject.uuid}`);
      setChats(response.data.chats || []);
    } catch (err) {
      console.error('Error fetching chats:', err);
    }
  };

  const fetchFolders = async () => {
    if (!selectedProject) return;
    try {
      const response = await axios.get(`/api/folders?project_uuid=${selectedProject.uuid}`);
      setFolders(response.data.folders || []);
    } catch (err) {
      console.error('Error fetching folders:', err);
    }
  };

  const fetchMembers = async () => {
    if (!selectedProject) return;
    try {
      const response = await axios.get(`/api/projects/${selectedProject.uuid}/members`);
      setMembers(response.data.members || []);
    } catch (err) {
      console.error('Error fetching members:', err);
    }
  };

  const handleProjectSelect = (project) => {
    navigate(`/projects/${project.uuid}`);
  };

  const handleCreateChat = async () => {
    if (!selectedProject) return;
    try {
      const data = {
        name: chatForm.name,
        description: chatForm.description,
        project_uuid: selectedProject.uuid,
      };
      if (chatForm.folder_id && chatForm.folder_id !== '') {
        data.folder_id = parseInt(chatForm.folder_id);
      }
      const response = await axios.post('/api/chats', data);
      setConnectionInfo({
        uuid: response.data.chat.uuid,
        name: response.data.chat.name,
      });
      setChatDialogOpen(false);
      setChatForm({ name: '', description: '', folder_id: '' });
      fetchChats();
      setSuccess('Чат создан');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка создания чата');
    }
  };

  const handleCreateFolder = async () => {
    if (!selectedProject) return;
    try {
      await axios.post('/api/folders', {
        ...folderForm,
        project_uuid: selectedProject.uuid,
      });
      setFolderDialogOpen(false);
      setFolderForm({ name: '', description: '', icon: 'Folder', color: '#1976d2' });
      fetchFolders();
      setSuccess('Папка создана');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка создания папки');
    }
  };

  const handleEditFolder = async () => {
    if (!selectedFolder) return;
    try {
      await axios.put(`/api/folders/${selectedFolder.id}`, folderForm);
      setEditFolderDialogOpen(false);
      setSelectedFolder(null);
      setFolderForm({ name: '', description: '', icon: 'Folder', color: '#1976d2' });
      fetchFolders();
      setSuccess('Папка обновлена');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка обновления папки');
    }
  };

  const handleDeleteFolder = async () => {
    if (!selectedFolder) return;
    try {
      await axios.delete(`/api/folders/${selectedFolder.id}`);
      setDeleteFolderDialogOpen(false);
      setSelectedFolder(null);
      fetchFolders();
      setSuccess('Папка удалена');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка удаления папки');
    }
  };

  const handleAddMember = async () => {
    if (!selectedProject || !userUuidInput.trim()) return;
    try {
      await axios.post(`/api/projects/${selectedProject.uuid}/members`, {
        user_uuid: userUuidInput.trim(),
        role: memberRole,
        chat_uuids: selectedChatsForMember,
      });
      setAddMemberDialogOpen(false);
      setUserUuidInput('');
      setSelectedChatsForMember([]);
      setMemberRole('member');
      fetchMembers();
      setSuccess('Участник добавлен');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка добавления участника');
    }
  };

  const handleEditMemberChats = async () => {
    if (!selectedProject || !selectedMemberForEdit) return;
    try {
      await axios.put(`/api/projects/${selectedProject.uuid}/members/${selectedMemberForEdit.id}/chats`, {
        chat_uuids: selectedChatsForMember,
      });
      setEditMemberChatsDialogOpen(false);
      setSelectedMemberForEdit(null);
      setSelectedChatsForMember([]);
      fetchMembers();
      setSuccess('Доступ к чатам обновлен');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка обновления доступа к чатам');
    }
  };

  const handleOpenEditMemberChats = (member) => {
    setSelectedMemberForEdit(member);
    setSelectedChatsForMember(member.allowed_chats?.map(c => c.uuid) || []);
    // Разворачиваем все папки по умолчанию
    const initialExpanded = {};
    folders.forEach(folder => {
      initialExpanded[String(folder.id)] = true;
    });
    setExpandedChatFolders(initialExpanded);
    setEditMemberChatsDialogOpen(true);
  };

  const handleRemoveMember = async (memberId) => {
    if (!selectedProject) return;
    try {
      await axios.delete(`/api/projects/${selectedProject.uuid}/members/${memberId}`);
      fetchMembers();
      setSuccess('Участник удален');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка удаления участника');
    }
  };


  const handleCopyUUID = (uuid) => {
    navigator.clipboard.writeText(`connect ${uuid}`);
    setSuccess('UUID скопирован в буфер обмена');
  };

  const handleRefreshChatIcon = async (chatUuid) => {
    try {
      setLoading(true);
      await axios.put(`/api/chats/${chatUuid}/refresh-icon`);
      fetchChats();
      setSuccess('Иконка чата обновлена');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка обновления иконки чата');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteChat = async () => {
    if (!selectedChatForDelete) return;
    try {
      await axios.delete(`/api/chats/${selectedChatForDelete.uuid}`);
      setDeleteChatDialogOpen(false);
      setSelectedChatForDelete(null);
      fetchChats();
      setSuccess('Чат удален');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка удаления чата');
    }
  };

  const handleMoveChat = async (folderId) => {
    if (!selectedChatForMove) return;
    try {
      await axios.post(`/api/folders/${folderId || 'null'}/move-chat/${selectedChatForMove.uuid}`);
      setMoveChatDialogOpen(false);
      setSelectedChatForMove(null);
      fetchChats();
      setSuccess('Чат перемещен');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка перемещения чата');
    }
  };

  // Проверка, является ли пользователь менеджером в проекте
  const isManagerInProject = () => {
    if (!selectedProject || !user) return false;
    // Проверяем через members - ищем текущего пользователя в списке участников с ролью manager
    const currentUserMember = members.find(m => m.user_uuid === user.uuid);
    return currentUserMember && currentUserMember.role === 'manager';
  };

  const canManage = () => {
    if (!selectedProject || !user) return false;
    return (
      user.role === 'admin' ||
      user.role === 'super_admin' ||
      selectedProject.created_by_uuid === user.uuid ||
      isManagerInProject()
    );
  };

  // Менеджер может создавать чаты и добавлять сотрудников
  const canCreateChats = () => {
    if (!selectedProject || !user) return false;
    return (
      user.role === 'admin' ||
      user.role === 'super_admin' ||
      selectedProject.created_by_uuid === user.uuid ||
      isManagerInProject()
    );
  };

  // Менеджер может добавлять сотрудников
  const canAddMembers = () => {
    if (!selectedProject || !user) return false;
    return (
      user.role === 'admin' ||
      user.role === 'super_admin' ||
      selectedProject.created_by_uuid === user.uuid ||
      isManagerInProject()
    );
  };

  if (!selectedProject && projects.length === 0) {
    return (
      <Layout>
        <Container>
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="h5">Нет доступных проектов</Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/projects')}
              sx={{ mt: 2 }}
            >
              Создать проект
            </Button>
          </Box>
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Box sx={{ display: 'flex' }}>
        {/* Левое меню с проектами */}
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              mt: 8,
            },
          }}
        >
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Typography variant="h6">Проекты</Typography>
          </Box>
          <List>
            {projects.map((project) => (
              <ListItem key={project.uuid} disablePadding>
                <ListItemButton
                  selected={selectedProject?.uuid === project.uuid}
                  onClick={() => handleProjectSelect(project)}
                >
                  <WorkIcon sx={{ mr: 1 }} />
                  <ListItemText
                    primary={project.name}
                    secondary={project.status !== 'active' ? 'Неактивен' : ''}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>

        {/* Основной контент */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          {selectedProject && (
            <>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h4" gutterBottom>
                  {selectedProject.name}
                </Typography>
                {selectedProject.description && (
                  <Typography variant="body1" color="text.secondary">
                    {selectedProject.description}
                  </Typography>
                )}
              </Box>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                  {error}
                </Alert>
              )}

              {success && (
                <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                  {success}
                </Alert>
              )}

              {connectionInfo && (
                <Alert
                  severity="info"
                  sx={{ mb: 2 }}
                  onClose={() => setConnectionInfo(null)}
                  action={
                    <Button
                      size="small"
                      onClick={() => handleCopyUUID(connectionInfo.uuid)}
                      startIcon={<ContentCopyIcon />}
                    >
                      Копировать
                    </Button>
                  }
                >
                  Отправьте в Telegram: connect {connectionInfo.uuid}
                </Alert>
              )}

              <Paper sx={{ mb: 3 }}>
                <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
                  <Tab icon={<ChatIcon />} label="Чаты" />
                  <Tab icon={<FolderIcon />} label="Папки" />
                  {(canManage() || canAddMembers()) && <Tab icon={<PeopleIcon />} label="Сотрудники" />}
                </Tabs>
              </Paper>

              {/* Вкладка Чаты */}
              {tabValue === 0 && (
                <Box>
                  {(canManage() || canCreateChats()) && (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setChatForm({ name: '', description: '', folder_id: '' });
                        setChatDialogOpen(true);
                      }}
                      sx={{ mb: 2 }}
                    >
                      Создать чат
                    </Button>
                  )}
                  <Grid container spacing={2}>
                    {chats.map((chat) => (
                      <Grid item xs={12} md={6} key={chat.uuid}>
                        <Card>
                          <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                              <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                  <Avatar 
                                    src={chat.icon_url} 
                                    sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}
                                  >
                                    {!chat.icon_url && <ChatIcon />}
                                  </Avatar>
                                  <Typography variant="h6">{chat.name}</Typography>
                                  {chat.folder_name && (
                                    <Chip
                                      icon={<FolderIcon />}
                                      label={chat.folder_name}
                                      size="small"
                                      variant="outlined"
                                      color="primary"
                                    />
                                  )}
                                </Box>
                                <Typography 
                                  variant="body2" 
                                  color="text.secondary"
                                  sx={{ minHeight: chat.description ? 'auto' : '20px', mb: chat.description ? 0.5 : 0 }}
                                >
                                  {chat.description || '\u00A0'}
                                </Typography>
                                {canManage() && (
                                  <>
                                    <Chip
                                      label={chat.status === 'connected' ? 'Подключен' : 'Не подключен'}
                                      color={chat.status === 'connected' ? 'success' : 'default'}
                                      size="small"
                                      sx={{ mt: 1 }}
                                    />
                                    {chat.status !== 'connected' && (
                                      <Alert severity="info" sx={{ mt: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                                          Инструкция по подключению:
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                          1. Добавьте бота в ваш Telegram чат
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                          2. Отправьте в чат сообщение:
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              fontFamily: 'monospace',
                                              bgcolor: 'grey.100',
                                              p: 1,
                                              borderRadius: 1,
                                              flex: 1,
                                            }}
                                          >
                                            connect {chat.uuid}
                                          </Typography>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleCopyUUID(chat.uuid)}
                                            color="primary"
                                          >
                                            <ContentCopyIcon />
                                          </IconButton>
                                        </Box>
                                      </Alert>
                                    )}
                                  </>
                                )}
                              </Box>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                {canManage() && chat.status === 'connected' && (
                                  <>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleRefreshChatIcon(chat.uuid)}
                                      title="Обновить иконку чата"
                                    >
                                      <RefreshIcon />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleCopyUUID(chat.uuid)}
                                      title="Копировать UUID"
                                    >
                                      <ContentCopyIcon />
                                    </IconButton>
                                  </>
                                )}
                                {canManage() && (
                                  <>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedChatForMove(chat);
                                        setMoveChatDialogOpen(true);
                                      }}
                                      title="Переместить в папку"
                                    >
                                      <FolderIcon />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => {
                                        setSelectedChatForDelete(chat);
                                        setDeleteChatDialogOpen(true);
                                      }}
                                      title="Удалить чат"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </>
                                )}
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}

              {/* Вкладка Папки */}
              {tabValue === 1 && (
                <Box>
                  {canManage() && (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setFolderForm({ name: '', description: '', icon: 'Folder', color: '#1976d2' });
                        setFolderDialogOpen(true);
                      }}
                      sx={{ mb: 2 }}
                    >
                      Создать папку
                    </Button>
                  )}
                  <Grid container spacing={2}>
                    {folders.map((folder) => {
                      const FolderIconComponent = getIconComponent(folder.icon);
                      return (
                        <Grid item xs={12} md={6} key={folder.id}>
                          <Card>
                            <CardContent>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex', gap: 2, flex: 1 }}>
                                  <FolderIconComponent sx={{ fontSize: 40, color: folder.color || 'primary.main', mt: 0.5 }} />
                                  <Box>
                                    <Typography variant="h6">{folder.name}</Typography>
                                    {folder.description && (
                                      <Typography variant="body2" color="text.secondary">
                                        {folder.description}
                                      </Typography>
                                    )}
                                    <Chip
                                      label={`${folder.chats_count || 0} чатов`}
                                      size="small"
                                      sx={{ mt: 1 }}
                                    />
                                  </Box>
                                </Box>
                              {canManage() && (
                                <Box>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setSelectedFolder(folder);
                                      setFolderForm({
                                        name: folder.name,
                                        description: folder.description || '',
                                        icon: folder.icon || 'Folder',
                                        color: folder.color || '#1976d2',
                                      });
                                      setEditFolderDialogOpen(true);
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                      setSelectedFolder(folder);
                                      setDeleteFolderDialogOpen(true);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Box>
                              )}
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              )}

              {/* Вкладка Сотрудники */}
              {tabValue === 2 && (canManage() || canAddMembers()) && (
                <Box>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      setUserUuidInput('');
                      setSelectedChatsForMember([]);
                      // Разворачиваем все папки по умолчанию
                      const initialExpanded = {};
                      folders.forEach(folder => {
                        initialExpanded[String(folder.id)] = true;
                      });
                      setExpandedChatFolders(initialExpanded);
                      setAddMemberDialogOpen(true);
                    }}
                    sx={{ mb: 2 }}
                  >
                    Добавить сотрудника
                  </Button>
                  <Grid container spacing={2}>
                    {members.map((member) => (
                      <Grid item xs={12} md={6} key={member.id}>
                        <Card>
                          <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="h6">{member.username}</Typography>
                                <Chip
                                  label={member.role === 'member' ? 'Участник' : member.role === 'manager' ? 'Менеджер' : member.role}
                                  size="small"
                                  color={member.role === 'manager' ? 'primary' : 'default'}
                                  sx={{ mt: 1, mr: 1 }}
                                />
                                {member.allowed_chats && member.allowed_chats.length > 0 ? (
                                  <Chip
                                    label={`Доступ к ${member.allowed_chats.length} чатам`}
                                    size="small"
                                    color="primary"
                                    sx={{ mt: 1, mr: 1 }}
                                  />
                                ) : (
                                  <Chip
                                    label="Доступ ко всем чатам"
                                    size="small"
                                    color="default"
                                    sx={{ mt: 1, mr: 1 }}
                                  />
                                )}
                                {member.added_at && (
                                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                    Добавлен: {new Date(member.added_at).toLocaleString('ru-RU', {
                                      year: 'numeric',
                                      month: 'long',
                                      day: 'numeric',
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    })}
                                  </Typography>
                                )}
                              </Box>
                              <Box>
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={() => handleOpenEditMemberChats(member)}
                                  sx={{ mr: 1 }}
                                >
                                  <EditIcon />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => handleRemoveMember(member.id)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              )}
            </>
          )}
        </Box>
      </Box>

      {/* Диалог создания чата */}
      <Dialog open={chatDialogOpen} onClose={() => setChatDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Создать чат</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Название чата"
            value={chatForm.name}
            onChange={(e) => setChatForm({ ...chatForm, name: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Описание"
            value={chatForm.description}
            onChange={(e) => setChatForm({ ...chatForm, description: e.target.value })}
            margin="normal"
            multiline
            rows={2}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Папка</InputLabel>
            <Select
              value={chatForm.folder_id}
              onChange={(e) => setChatForm({ ...chatForm, folder_id: e.target.value })}
              label="Папка"
            >
              <MenuItem value="">Без папки</MenuItem>
              {folders.map((folder) => (
                <MenuItem key={folder.id} value={folder.id}>
                  {folder.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setChatDialogOpen(false)}>Отмена</Button>
          <Button onClick={handleCreateChat} variant="contained" disabled={!chatForm.name.trim()}>
            Создать
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог создания папки */}
      <Dialog open={folderDialogOpen} onClose={() => setFolderDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Создать папку</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Название папки"
            value={folderForm.name}
            onChange={(e) => setFolderForm({ ...folderForm, name: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Описание"
            value={folderForm.description}
            onChange={(e) => setFolderForm({ ...folderForm, description: e.target.value })}
            margin="normal"
            multiline
            rows={2}
          />
          <Box sx={{ mt: 2, mb: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              Иконка папки
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              {(() => {
                const SelectedIcon = getIconComponent(folderForm.icon);
                return <SelectedIcon sx={{ fontSize: 40, color: folderForm.color || 'primary.main' }} />;
              })()}
              <Button
                variant="outlined"
                onClick={() => setIconPickerOpen(true)}
                size="small"
              >
                Выбрать иконку
              </Button>
            </Box>
          </Box>
          <Box sx={{ mt: 2, mb: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Цвет папки</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: 1,
                  backgroundColor: folderForm.color || '#1976d2',
                  border: '2px solid',
                  borderColor: 'divider',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 1,
                }}
              >
                <Typography variant="caption" sx={{ color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>
                  {folderForm.color || '#1976d2'}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <input
                  type="color"
                  value={folderForm.color || '#1976d2'}
                  onChange={(e) => setFolderForm({ ...folderForm, color: e.target.value })}
                  style={{
                    width: '100%',
                    height: '40px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    cursor: 'pointer',
                  }}
                />
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFolderDialogOpen(false)}>Отмена</Button>
          <Button onClick={handleCreateFolder} variant="contained" disabled={!folderForm.name.trim()}>
            Создать
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог редактирования папки */}
      <Dialog open={editFolderDialogOpen} onClose={() => setEditFolderDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Редактировать папку</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Название папки"
            value={folderForm.name}
            onChange={(e) => setFolderForm({ ...folderForm, name: e.target.value })}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Описание"
            value={folderForm.description}
            onChange={(e) => setFolderForm({ ...folderForm, description: e.target.value })}
            margin="normal"
            multiline
            rows={2}
          />
          <Box sx={{ mt: 2, mb: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              Иконка папки
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              {(() => {
                const SelectedIcon = getIconComponent(folderForm.icon);
                return <SelectedIcon sx={{ fontSize: 40, color: folderForm.color || 'primary.main' }} />;
              })()}
              <Button
                variant="outlined"
                onClick={() => setIconPickerOpen(true)}
                size="small"
              >
                Выбрать иконку
              </Button>
            </Box>
          </Box>
          <Box sx={{ mt: 2, mb: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Цвет папки</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: 1,
                  backgroundColor: folderForm.color || '#1976d2',
                  border: '2px solid',
                  borderColor: 'divider',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 1,
                }}
              >
                <Typography variant="caption" sx={{ color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>
                  {folderForm.color || '#1976d2'}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <input
                  type="color"
                  value={folderForm.color || '#1976d2'}
                  onChange={(e) => setFolderForm({ ...folderForm, color: e.target.value })}
                  style={{
                    width: '100%',
                    height: '40px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    cursor: 'pointer',
                  }}
                />
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditFolderDialogOpen(false)}>Отмена</Button>
          <Button onClick={handleEditFolder} variant="contained" disabled={!folderForm.name.trim()}>
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог выбора иконки */}
      <Dialog open={iconPickerOpen} onClose={() => setIconPickerOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Выберите иконку</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {Object.keys(folderIcons).map((iconName) => {
              const IconComponent = folderIcons[iconName];
              const isSelected = folderForm.icon === iconName;
              return (
                <Grid item xs={3} sm={2} key={iconName}>
                  <Box
                    onClick={() => {
                      setFolderForm({ ...folderForm, icon: iconName });
                      setIconPickerOpen(false);
                    }}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 2,
                      border: isSelected ? 2 : 1,
                      borderColor: isSelected ? 'primary.main' : 'divider',
                      borderRadius: 2,
                      cursor: 'pointer',
                      bgcolor: isSelected ? 'action.selected' : 'transparent',
                      '&:hover': {
                        bgcolor: 'action.hover',
                      },
                    }}
                  >
                    <IconComponent sx={{ fontSize: 32, color: isSelected ? (folderForm.color || 'primary.main') : 'text.primary' }} />
                    <Typography variant="caption" sx={{ mt: 1, textAlign: 'center' }}>
                      {iconName}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIconPickerOpen(false)}>Закрыть</Button>
        </DialogActions>
      </Dialog>

      {/* Диалог удаления папки */}
      <Dialog open={deleteFolderDialogOpen} onClose={() => setDeleteFolderDialogOpen(false)}>
        <DialogTitle>Удалить папку?</DialogTitle>
        <DialogContent>
          <Typography>
            Вы уверены, что хотите удалить папку "{selectedFolder?.name}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteFolderDialogOpen(false)}>Отмена</Button>
          <Button onClick={handleDeleteFolder} variant="contained" color="error">
            Удалить
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог перемещения чата */}
      <Dialog open={moveChatDialogOpen} onClose={() => {
        setMoveChatDialogOpen(false);
        setSelectedChatForMove(null);
      }} maxWidth="sm" fullWidth>
        <DialogTitle>Переместить чат в папку</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Чат: {selectedChatForMove?.name}
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Выберите папку</InputLabel>
            <Select
              value={selectedChatForMove?.folder_id || 'no-folder'}
              onChange={(e) => {
                const folderId = e.target.value === 'no-folder' ? null : e.target.value;
                handleMoveChat(folderId);
              }}
              label="Выберите папку"
            >
              <MenuItem value="no-folder">Без папки</MenuItem>
              {folders.map((folder) => (
                <MenuItem key={folder.id} value={folder.id}>
                  {folder.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setMoveChatDialogOpen(false);
            setSelectedChatForMove(null);
          }}>
            Отмена
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог удаления чата */}
      <Dialog open={deleteChatDialogOpen} onClose={() => {
        setDeleteChatDialogOpen(false);
        setSelectedChatForDelete(null);
      }}>
        <DialogTitle>Удалить чат?</DialogTitle>
        <DialogContent>
          <Typography>
            Вы уверены, что хотите удалить чат "{selectedChatForDelete?.name}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setDeleteChatDialogOpen(false);
            setSelectedChatForDelete(null);
          }}>
            Отмена
          </Button>
          <Button onClick={handleDeleteChat} variant="contained" color="error">
            Удалить
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог добавления сотрудника */}
      <Dialog open={addMemberDialogOpen} onClose={() => {
        setAddMemberDialogOpen(false);
        setUserUuidInput('');
        setSelectedChatsForMember([]);
        setMemberRole('member');
      }} maxWidth="sm" fullWidth>
        <DialogTitle>Добавить сотрудника</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="UUID пользователя"
            value={userUuidInput}
            onChange={(e) => setUserUuidInput(e.target.value)}
            margin="normal"
            required
            helperText="Введите UUID пользователя для добавления в проект"
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Роль в проекте</InputLabel>
            <Select
              value={memberRole}
              onChange={(e) => setMemberRole(e.target.value)}
              label="Роль в проекте"
            >
              <MenuItem value="member">Участник</MenuItem>
              <MenuItem value="manager">Менеджер</MenuItem>
            </Select>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
              Менеджер может создавать чаты и добавлять сотрудников в проект
            </Typography>
          </FormControl>
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Доступ к чатам (если не выбрано - доступ ко всем чатам)
            </Typography>
            <Box sx={{ maxHeight: 400, overflow: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1 }}>
              {(() => {
                const projectChats = chats.filter(c => c.project_uuid === selectedProject?.uuid);
                const chatsByFolder = projectChats.reduce((acc, chat) => {
                  const folderId = chat.folder_id ? String(chat.folder_id) : 'no-folder';
                  if (!acc[folderId]) {
                    acc[folderId] = [];
                  }
                  acc[folderId].push(chat);
                  return acc;
                }, {});
                
                const noFolderChats = chatsByFolder['no-folder'] || [];
                const folderChats = Object.entries(chatsByFolder).filter(([id]) => id !== 'no-folder');
                
                return (
                  <>
                    {folderChats.map(([folderId, folderChatsList]) => {
                      const folder = folders.find(f => String(f.id) === folderId);
                      if (!folder) return null;
                      const isExpanded = expandedChatFolders[folderId] !== false;
                      const FolderIconComponent = getIconComponent(folder.icon);
                      
                      return (
                        <Box key={folderId} sx={{ mb: 1 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              p: 1,
                              cursor: 'pointer',
                              borderRadius: 1,
                              '&:hover': { bgcolor: 'action.hover' },
                            }}
                            onClick={() => setExpandedChatFolders(prev => ({ ...prev, [folderId]: !isExpanded }))}
                          >
                            <FolderIconComponent sx={{ mr: 1, color: folder.color || 'primary.main', fontSize: 20 }} />
                            <Typography variant="subtitle2" sx={{ flex: 1 }}>
                              {folder.name}
                            </Typography>
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </Box>
                          <Collapse in={isExpanded}>
                            <Box sx={{ pl: 3, pr: 1 }}>
                              {folderChatsList.map((chat) => (
                                <FormControlLabel
                                  key={chat.uuid}
                                  control={
                                    <Checkbox
                                      checked={selectedChatsForMember.includes(chat.uuid)}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedChatsForMember([...selectedChatsForMember, chat.uuid]);
                                        } else {
                                          setSelectedChatsForMember(selectedChatsForMember.filter(u => u !== chat.uuid));
                                        }
                                      }}
                                    />
                                  }
                                  label={chat.name}
                                  sx={{ display: 'block', mb: 0.5 }}
                                />
                              ))}
                            </Box>
                          </Collapse>
                        </Box>
                      );
                    })}
                    {noFolderChats.length > 0 && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="subtitle2" sx={{ p: 1, fontWeight: 600 }}>
                          Без папки
                        </Typography>
                        <Box sx={{ pl: 1 }}>
                          {noFolderChats.map((chat) => (
                            <FormControlLabel
                              key={chat.uuid}
                              control={
                                <Checkbox
                                  checked={selectedChatsForMember.includes(chat.uuid)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedChatsForMember([...selectedChatsForMember, chat.uuid]);
                                    } else {
                                      setSelectedChatsForMember(selectedChatsForMember.filter(u => u !== chat.uuid));
                                    }
                                  }}
                                />
                              }
                              label={chat.name}
                              sx={{ display: 'block', mb: 0.5 }}
                            />
                          ))}
                        </Box>
                      </Box>
                    )}
                  </>
                );
              })()}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setAddMemberDialogOpen(false);
            setUserUuidInput('');
            setSelectedChatsForMember([]);
          }}>Отмена</Button>
          <Button onClick={handleAddMember} variant="contained" disabled={!userUuidInput.trim()}>
            Добавить
          </Button>
        </DialogActions>
      </Dialog>

      {/* Диалог редактирования доступа к чатам */}
      <Dialog open={editMemberChatsDialogOpen} onClose={() => {
        setEditMemberChatsDialogOpen(false);
        setSelectedMemberForEdit(null);
        setSelectedChatsForMember([]);
      }} maxWidth="sm" fullWidth>
        <DialogTitle>
          Доступ к чатам: {selectedMemberForEdit?.username}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Если не выбрано ни одного чата - доступ ко всем чатам проекта
          </Typography>
          <Box sx={{ maxHeight: 400, overflow: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1 }}>
            {(() => {
              const projectChats = chats.filter(c => c.project_uuid === selectedProject?.uuid);
              const chatsByFolder = projectChats.reduce((acc, chat) => {
                const folderId = chat.folder_id ? String(chat.folder_id) : 'no-folder';
                if (!acc[folderId]) {
                  acc[folderId] = [];
                }
                acc[folderId].push(chat);
                return acc;
              }, {});
              
              const noFolderChats = chatsByFolder['no-folder'] || [];
              const folderChats = Object.entries(chatsByFolder).filter(([id]) => id !== 'no-folder');
              
              return (
                <>
                  {folderChats.map(([folderId, folderChatsList]) => {
                    const folder = folders.find(f => String(f.id) === folderId);
                    if (!folder) return null;
                    const isExpanded = expandedChatFolders[folderId] !== false;
                    const FolderIconComponent = getIconComponent(folder.icon);
                    
                    return (
                      <Box key={folderId} sx={{ mb: 1 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1,
                            cursor: 'pointer',
                            borderRadius: 1,
                            '&:hover': { bgcolor: 'action.hover' },
                          }}
                          onClick={() => setExpandedChatFolders(prev => ({ ...prev, [folderId]: !isExpanded }))}
                        >
                          <FolderIconComponent sx={{ mr: 1, color: folder.color || 'primary.main', fontSize: 20 }} />
                          <Typography variant="subtitle2" sx={{ flex: 1 }}>
                            {folder.name}
                          </Typography>
                          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </Box>
                        <Collapse in={isExpanded}>
                          <Box sx={{ pl: 3, pr: 1 }}>
                            {folderChatsList.map((chat) => (
                              <FormControlLabel
                                key={chat.uuid}
                                control={
                                  <Checkbox
                                    checked={selectedChatsForMember.includes(chat.uuid)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedChatsForMember([...selectedChatsForMember, chat.uuid]);
                                      } else {
                                        setSelectedChatsForMember(selectedChatsForMember.filter(u => u !== chat.uuid));
                                      }
                                    }}
                                  />
                                }
                                label={chat.name}
                                sx={{ display: 'block', mb: 0.5 }}
                              />
                            ))}
                          </Box>
                        </Collapse>
                      </Box>
                    );
                  })}
                  {noFolderChats.length > 0 && (
                    <Box sx={{ mt: 1 }}>
                      <Typography variant="subtitle2" sx={{ p: 1, fontWeight: 600 }}>
                        Без папки
                      </Typography>
                      <Box sx={{ pl: 1 }}>
                        {noFolderChats.map((chat) => (
                          <FormControlLabel
                            key={chat.uuid}
                            control={
                              <Checkbox
                                checked={selectedChatsForMember.includes(chat.uuid)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedChatsForMember([...selectedChatsForMember, chat.uuid]);
                                  } else {
                                    setSelectedChatsForMember(selectedChatsForMember.filter(u => u !== chat.uuid));
                                  }
                                }}
                              />
                            }
                            label={chat.name}
                            sx={{ display: 'block', mb: 0.5 }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                </>
              );
            })()}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setEditMemberChatsDialogOpen(false);
            setSelectedMemberForEdit(null);
            setSelectedChatsForMember([]);
          }}>Отмена</Button>
          <Button onClick={handleEditMemberChats} variant="contained">
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </Layout>
  );
};

export default ProjectManagement;
